import { PortMarocService } from './../../../../Service/port-maroc.service';
import { Global } from 'src/app/Service/global.service';
import { Component, OnInit } from '@angular/core';
import { takeUntil } from 'rxjs/operators';
import { ActivatedRoute, Router } from '@angular/router';
import { forkJoin } from 'rxjs';
declare var $: any;
@Component({
  selector: 'app-portcontent',
  templateUrl: './portcontent.component.html',
  styleUrls: ['./portcontent.component.scss']
})
export class PortcontentComponent implements OnInit {
ports = [];
selectedPort = null;
menuPort = [];
staticContent = true;
pageDynamique = '';
  constructor(private global:Global, private portService:PortMarocService, private router: Router, private route:ActivatedRoute) { }

  ngOnInit(): void {
    this.global.CurentLanguage.subscribe(lg => {
      const currentUrl = this.router.url;
      this.ports = [];
      this.portService.getPortData().subscribe(datas => {
        datas['value'].forEach(element => {
        
          const obj = {
            port: element.CodePort, 
            pathPort : element.CodePort.toLowerCase().split('ports.port')[1],
            region: element.CodeRegion, 
            idPort:element.IdPort,
            SitePlan: element.PlanSite
          };
          this.ports.push(obj);
          
        });
        const prefixUrl = this.router.url.toLowerCase().split('/page/')[0];
        const portSelected = prefixUrl.split('/')[prefixUrl.split('/').length -1];
        this.selectedPort = null; 
        this.ports.forEach(element => {
          if(portSelected === element.pathPort) {
            this.selectedPort = element;
          }
        });
        if(this.selectedPort === null && currentUrl.indexOf('/port') !== -1 && currentUrl !== '/portmaroc') {
          alert('Le port inexistant ');

        } else {
          this.menuPort = [];
          this.portService.getMenuData().subscribe(datas => {
            const requests = [];
            const menuDynamique = [];
            datas['value'].forEach(element => {
              
              if(!element.PageDynamique) {
            
                menuDynamique.push(element);
                requests.push(this.portService.getMenuPageData(this.selectedPort.port, element.ListeReference,lg.code));
              } else {
                let menuTitle = '';
                if(lg.code === 'fr') {
                  menuTitle = element.Title
                } else if(lg.code === 'ar') {
                 menuTitle = element.TitreAR
               } else  {
                 menuTitle =element.TitreEN
               }
                const obj = {
                  title: menuTitle, 
                  url : element.ApplicationUrl,
                  Ordre: element.Ordre,
                  item: null
      
                }
                if(obj.url !=='MouvementNavires'  || (obj.url ==='MouvementNavires' && this.selectedPort.idPort !== null && this.selectedPort.idPort !== undefined))
               { this.menuPort.push(obj);
                
              }
              }
            });
         
            
            forkJoin(requests).subscribe(dataItems => {
              let i = 0;
              dataItems.forEach(list => {
                
                if(list['value'].length > 0) {
                 let menuTitle = '';
                 if(lg.code === 'fr') {
                   menuTitle = menuDynamique[i].Title
                 } else if(lg.code === 'ar') {
                  menuTitle = menuDynamique[i].TitreAR
                } else  {
                  menuTitle = menuDynamique[i].TitreEN
                }
                const obj = {
                  title: menuTitle, 
                  url : menuDynamique[i].ApplicationUrl,
                  Ordre: menuDynamique[i].Ordre,
                  item: list['value']
      
                }
                  this.menuPort.push(obj);
                }
                i++;
              });
        
            
           this.route.params.subscribe(params => {
            if(params['page'] === undefined || params['page'] === null || params['page'] === '') {
              if(this.menuPort[0].item !== null) {
                const url = this.global._baseUrlRacine + this.menuPort[0].item[0].File.ServerRelativeUrl;
                $('#content').load(url,()=>{
                  $('#content style').remove();
                });
              }
           
            }else {
              this.menuPort.forEach( port => {
               
                if(port.url.toLowerCase() === params['page'].toLowerCase() && port.item !== null) {
                  this.staticContent = true;
                  const url = this.global._baseUrlRacine + port.item[0].File.ServerRelativeUrl;
                  $('#content').load(url,()=>{
                    $('#content style').remove();
                  });
                } else if(port.url.toLowerCase() === params['page'].toLowerCase() && port.item === null) {
                  this.staticContent =false;
                  this.pageDynamique = params['page'].toLowerCase();
                  if(this.pageDynamique === 'mouvementnavires') {
                    if(this.selectedPort === null  ) {
                      alert('Le port inexistant ');
                          
                        } else if (this.selectedPort.idPort === null || this.selectedPort.idPort === undefined) {
                          this.staticContent = true;
                            let pageExist = false ;
                            let pageId = 0;
                            let i = 0;
                            this.menuPort.forEach(menu => {
                              if(menu.item !== null && !pageExist) {
                                pageId = i;
                                pageExist = true;
                              }
                              i++;
                            });
                            // const url = this.global._baseUrlRacine + this.menuPort[pageId].item[0].File.ServerRelativeUrl;
                            // $('#content').load(url,()=>{
                            //   $('#content style').remove();
                            // });
                            alert('Mouvement navire inexistant pour ce port');
                            const urls = currentUrl.split('/');
                            urls[urls.length -1] = this.menuPort[pageId].url
                            const newUrl = urls.join('/');
                      
                            this.router.navigate([newUrl]);
                            
                        
                        }
                   
                  } else if(this.pageDynamique === 'planacces') {
                     if(this.selectedPort.SitePlan !== null && this.selectedPort.SitePlan !== undefined && this.selectedPort.SitePlan !== '' ) {
                    setTimeout(() => {
                      document.getElementById('MapFrame')['src'] = this.selectedPort.SitePlan
                    }, 1000);
                    
                      
                     }
                    
                  }
                 
                }
              });
            }
            
           });
            });     
            });
        }
       
      });
     
      
    });
  }
//   ngOnDestroy() {
//     this.global.CurentLanguage.unsubscribe()
// }

}
